import { RectSize } from '../../../common/maths/geometry/rect/rectTypes';
import { Point } from '../../../common/maths/geometry/pointTypes';

// Rule for whether to maintain aspect ratio when resizing
export enum MaintainAspectRatioMode {
    ALWAYS = 'always',
    OPTIONAL = 'optional', // e.g. hold command to change aspect ratio
    NEVER = 'never',
}

// Rule for what kind of aspect ratio to maintain, if any
export enum ResizeAspectLock {
    ELEMENT = 'element',
    MEDIA = 'media',
    NONE = 'none',
}

export type ResizeChanges = Partial<{
    width: number;
    height: number;
    maxHeight: string | number;
    media: RectSize;
    drawing: RectSize;
    showMediaOnly: boolean;
}> | null;

export type SetElementSizeAndPosition = (changes: ResizeChanges, position?: Point) => void;
export type SetTempElementSize = (size: RectSize | null) => void;

export enum MediaElementContentVisibility {
    SHOW_ALL = 'showAll',
    SHOW_MEDIA_ONLY = 'showMediaOnly',
    UNSET = 'unset',
}
